import React from "react";
import { XIcon } from "@heroicons/react/outline";
import newExperienceImage from "../../assets/images/new-experience.png";

const TryNewExperienceModal = (props) => {
  return (
    <section className="flex flex-col flex-1">
      <section
        className="flex items-center p-3 justify-between px-5 py-6 border-b"
        style={{ backgroundColor: "#F4F9FE" }}
      >
        <div className="text-2xl font-bold" style={{ color: "#38405C" }}>
          <span>Go to the new Content Camel Experience</span>
        </div>
        <XIcon className="h-6 w-6 text-black cursor-pointer" onClick={props.onClose} />
      </section>
      <section className="flex flex-1 p-8 pt-8 gap-4">
        <article className="flex">
          <div className="h-full relative flex-1 max-w-xs">
            <img src={newExperienceImage} alt="New Content Camel Experience" className="w-full" />
          </div>
        </article>
        <article className="flex-1 text-left flex flex-col px-2 gap-4">
          <span className="font-bold text-xl" style={{ color: "#38405C" }}>
            You are about to jump into the new Content Camel Experience
          </span>
          <div style={{ color: "#38405C" }} className="space-y-4">
            <p>
              We are implementing a <strong>new and improved user interface</strong> that's more instinctive and usable.
              You can continue working in this updated interface with all of your current assets and collections.
            </p>
            
            <p>
              Currently, this is in preview mode for admins only, and <strong>we appreciate your early feedback</strong>. We'll be making
              this available to all users in the coming days -- eventually replacing the old experience.
            </p>
            <p>For now, no worries, you can <strong>go back to the current experience at any time.</strong></p>
          </div>
        </article>
      </section>
      <section className="pt-2 px-6 mb-6 flex justify-end"></section>
      <article className="flex gap-4 justify-end p-4">
        <button
          style={{ backgroundColor: "#039FAB" }}
          className="border items-center gap-1 py-2 px-4 rounded-lg text-white h-fit"
          onClick={props.onUpdateUserNewExperienceFlag}
        >
          Ok
        </button>
      </article>
    </section>
  );
};

export default TryNewExperienceModal;
